export function agoraSupportCode(payload) {
  return {
    type: "AGORA_SUPPORT_CODE",
    payload,
  };
}
